module.exports = function() {
  return new Worker(__webpack_public_path__ + "3f3857a21aa38bc5eb72.worker.js");
};